/* eslint camelcase: 0, global-require: 0 */
import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { get, set } from 'lodash';
import { routerMiddleware } from 'react-router-redux';
import { browserHistory } from 'react-router';
import { createLogger } from 'redux-logger';
import { batchedSubscribe } from 'redux-batched-subscribe';
import { unstable_batchedUpdates as batchedUpdates } from 'react-dom';
import appConfig from 'config';

import rootReducer from '../reducers';
import { appInsights, trackingIsActive } from '../insights';

const __PRODUCTION__ = __PRODUCTION__ || process.env.NODE_ENV === 'production'; // eslint-disable-line

const logger = createLogger({
  collapsed: true,
  predicate: () =>
    process.env.NODE_ENV === 'development',
});


export const insights = appInsights();
if (trackingIsActive) {
  insights.loadAppInsights();
  insights.addTelemetryInitializer((telemetry) => {
    set(telemetry, ['tags', 'ai.cloud.role'], 'Employee Web');
    set(telemetry, ['tags', 'ai.cloud.roleInstance'], get(appConfig, 'siteName'));
  });
}

const middlewares = [
  thunkMiddleware,
  routerMiddleware(browserHistory),
  !__PRODUCTION__ && logger,
].filter(Boolean);

const createStoreWithMiddleware = applyMiddleware(...middlewares)(createStore);

export default function configureStore(initialState) {
  const store = createStoreWithMiddleware(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), // eslint-disable-line no-underscore-dangle
    initialState,
    batchedSubscribe(batchedUpdates),
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../', () => {
      const nextRootReducer = require('../index').default;

      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js